export function isDefined(variable) {
    return !(typeof variable === 'undefined' || variable === null);
}